import { useEffect, useState } from "react";
import { Table, Button, Input, message, Select, Modal, Tag, Space } from "antd";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  calculare_medii,
  calculeaza_medie_materie,
} from "../utils/calculare_medie";
import { getDataDoc, updateDocDatabase } from "../database";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../database/firebase";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signOut,
  updateProfile,
} from "firebase/auth";
import { initializeApp } from "firebase/app";

function generateSixDigitCode() {
  return Math.floor(100000 + Math.random() * 900000);
}

function DateElevi({ classData }) {
  const [eleviData, setEleviData] = useState([]);
  const [sortType, setSortType] = useState("alfabetic");
  const [loading, setLoading] = useState(false);
  const [activeColumns, setActiveColumns] = useState([]);
  const [editingData, setEditingData] = useState({});
  const [saving, setSaving] = useState(false);
  const [savingIndividual, setSavingIndividual] = useState({});
  const [incompletStatusElevi, setIncompletStatusElevi] = useState([]);
  const [incompletFieldsData, setIncompleteFieldsData] = useState({});
  const [customStates, setCustomStates] = useState([]);
  const [showAddStateModal, setShowAddStateModal] = useState(false);
  const [newStateName, setNewStateName] = useState("");
  const [currentStateField, setCurrentStateField] = useState("");
  const [customAwards, setCustomAwards] = useState([]);
  const [showAddAwardModal, setShowAddAwardModal] = useState(false);
  const [newAwardName, setNewAwardName] = useState("");
  const [currentAwardField, setCurrentAwardField] = useState("");
  const materii = useSelector((state) => state.materii);
  const profesori = useSelector((state) => state.profesori);
  const navigate = useNavigate();

  // Predefined state options
  const defaultStates = ["Promovat", "Corigent", "Amânat", "Repetent"];

  // Predefined award options
  const defaultAwards = [
    "Premiul I",
    "Premiul II",
    "Premiul III",
    "Mențiunea I",
    "Mențiunea II",
    "Mențiunea III",
    "Mențiune",
    "-",
  ];

  // Load custom states from Firebase
  const loadCustomStates = async () => {
    try {
      const statesData = await getDataDoc("stari", "customStates");
      if (statesData?.states) {
        setCustomStates(statesData.states);
      }
    } catch (error) {
      console.error("Error loading custom states:", error);
    }
  };

  // Load custom awards from Firebase
  const loadCustomAwards = async () => {
    try {
      const awardsData = await getDataDoc("premii", "customAwards");
      if (awardsData?.awards) {
        setCustomAwards(awardsData.awards);
      }
    } catch (error) {
      console.error("Error loading custom awards:", error);
    }
  };

  // Save new custom state to Firebase
  const saveCustomState = async (stateName) => {
    try {
      const newStates = [...customStates, stateName];
      await updateDocDatabase("stari", "customStates", { states: newStates });
      setCustomStates(newStates);
      message.success(`Starea "${stateName}" a fost adăugată cu succes!`);
    } catch (error) {
      console.error("Error saving custom state:", error);
      message.error("Eroare la salvarea stării noi!");
    }
  };

  // Save new custom award to Firebase
  const saveCustomAward = async (awardName) => {
    try {
      const newAwards = [...customAwards, awardName];
      await updateDocDatabase("premii", "customAwards", { awards: newAwards });
      setCustomAwards(newAwards);
      message.success(`Premiul "${awardName}" a fost adăugat cu succes!`);
    } catch (error) {
      console.error("Error saving custom award:", error);
      message.error("Eroare la salvarea premiului nou!");
    }
  };

  // Handle adding new state
  const handleAddNewState = () => {
    if (!newStateName.trim()) {
      message.error("Introduceți un nume pentru starea nouă!");
      return;
    }

    const allStates = [...defaultStates, ...customStates];
    if (allStates.includes(newStateName.trim())) {
      message.error("Această stare există deja!");
      return;
    }

    saveCustomState(newStateName.trim());

    // Set the new state for the current field
    if (currentStateField) {
      const [elevId, field] = currentStateField.split("|");
      handleInputChange(elevId, field, newStateName.trim());
    }

    setNewStateName("");
    setShowAddStateModal(false);
    setCurrentStateField("");
  };

  // Handle adding new award
  const handleAddNewAward = () => {
    if (!newAwardName.trim()) {
      message.error("Introduceți un nume pentru premiul nou!");
      return;
    }

    const allAwards = [...defaultAwards, ...customAwards];
    if (allAwards.includes(newAwardName.trim())) {
      message.error("Acest premiu există deja!");
      return;
    }

    saveCustomAward(newAwardName.trim());

    // Set the new award for the current field
    if (currentAwardField) {
      const [elevId, field] = currentAwardField.split("|");
      handleInputChange(elevId, field, newAwardName.trim());
    }

    setNewAwardName("");
    setShowAddAwardModal(false);
    setCurrentAwardField("");
  };

  const availableColumns = [
    { key: "initiala", label: "Inițiala", dataKey: "initiala" },
    { key: "cnp", label: "CNP", dataKey: "cnp" },
    { key: "parintii", label: "Emailuri abonate", dataKey: "parintii" },
    { key: "numarMatricol", label: "Nr. Matricol", dataKey: "numarMatricol" },
    { key: "numarTelefon", label: "Nr. Telefon", dataKey: "numarTelefon" },
    { key: "domiciliu", label: "Domiciliu", dataKey: "domiciliu" },
    { key: "mama", label: "Prenume Mama", dataKey: "mama" },
    { key: "tata", label: "Tata", dataKey: "tata" },
    { key: "loculNasteri", label: "Locul Nașterii", dataKey: "loculNasteri" },
    { key: "bursa", label: "Bursă", dataKey: "bursa" },
    {
      key: "scutitMedical",
      label: "Cerere Scutire Medicală",
      dataKey: "scutitMedical",
    },
    {
      key: "dataExpirareMedical",
      label: "Data Expirare Medical",
      dataKey: "dataExpirareMedical",
    },
    { key: "ces", label: "CES", dataKey: "ces" },
    { key: "religie", label: "Religie", dataKey: "religie" },
    { key: "cerereReligie", label: "Cerere Religie", dataKey: "cerereReligie" },
    { key: "premiu", label: "Premiu", dataKey: "premiu" },
    { key: "profindr", label: "Prof. Îndr.", dataKey: "profindr" },
    { key: "insprin", label: "Ins. Prin.", dataKey: "insprin" },
    { key: "inssec", label: "Ins. Sec.", dataKey: "inssec" },
    { key: "details", label: "Detalii", dataKey: "details" },
    {
      key: "materiiSpecialitate",
      label: "Materii Speciale",
      dataKey: "materiiSpecialitate",
    },
    {
      key: "stareaLaIncheiereaCursurilor",
      label: "Starea la înch. cursurilor",
      dataKey: "stareaLaIncheiereaCursurilor",
    },
    {
      key: "stareaLaFinalulAnului",
      label: "Starea la finalul anului",
      dataKey: "stareaLaFinalulAnului",
    },
  ];
  useEffect(() => {
    // Load custom states and awards on component mount
    loadCustomStates();
    loadCustomAwards();
  }, []);

  useEffect(() => {
    const fetchEleviData = async () => {
      if (!classData?.elevi) return;

      setLoading(true);

      try {
        let scutiriElevi = {};
        const elevi = classData?.elevi || [];

        // --- Parallelize initial data fetching for all students ---
        const initialDataPromises = elevi.map(async (elev) => {
          const [docs, elevData, noteData] = await Promise.all([
            getDataDoc("eleviDocumente", elev.id),
            getDataDoc("elevi", elev.id),
            getDataDoc("catalog", elev.id),
          ]);
          return { elev, docs, elevData, noteData };
        });

        const initialResults = await Promise.all(initialDataPromises);

        // Prepare scutiri data
        initialResults.forEach(({ elev, docs }) => {
          scutiriElevi[elev.id] =
            docs?.docsElev?.filter(
              (doc) => doc.tip === "scutire" || doc.tip === "bilet"
            ) || [];
        });

        const eleviWithData = initialResults
          .map(({ elev, elevData, noteData }) => {
            if (elevData) {
              const elevId = elev.id;
              const scutiriElev = scutiriElevi[elevId];

              const mediaGenerala = calculare_medii(
                noteData?.note || [],
                classData?.materii.map((m) =>
                  materii?.find((c) => c.id === m.materie)
                ) || [],
                scutiriElev
              );

              const numeFormatat = `${elevData.numeDeFamilie || ""} ${
                elevData.initiala
              } ${elevData.prenume || ""}`;

              // Calculare materii cu probleme
              const materiiCuProbleme =
                classData?.materii?.reduce((arr, m) => {
                  if (!noteData?.note?.find((n) => n.materieId === m.materie))
                    return arr;

                  const medieMeta = calculeaza_medie_materie(
                    noteData?.note || [],
                    materii?.find((ma) => ma.id === m.materie),
                    scutiriElev
                  );

                  // Adaugă materia dacă:
                  // 1. Media < 5 și diferită de 0 (corigent), sau
                  // 2. Nu are media închisă (inchis !== true) și media >= 5
                  if (medieMeta.medie !== 0) {
                    if (medieMeta.medie < 5) {
                      return [
                        ...arr,
                        {
                          materieId: m.materie,
                          tip: "corigent",
                          media: medieMeta.medie,
                        },
                      ];
                    } else if (!medieMeta.inchis) {
                      return [
                        ...arr,
                        {
                          materieId: m.materie,
                          tip: "neinchis",
                          media: medieMeta.medie,
                        },
                      ];
                    }
                  }
                  return arr;
                }, []) || [];

              // Auto-set status based on subject problems
              let stareaLaIncheiereaCursurilor =
                elevData.stareaLaIncheiereaCursurilor || "";
              let stareaLaFinalulAnului = elevData.stareaLaFinalulAnului || "";

              if (
                !stareaLaIncheiereaCursurilor &&
                materiiCuProbleme?.length === 0 &&
                (noteData?.note || []).filter((n) => n.tip === "nota").length >
                  0
              ) {
                stareaLaIncheiereaCursurilor = "Promovat";
              }

              if (
                !stareaLaFinalulAnului &&
                materiiCuProbleme?.length === 0 &&
                (noteData?.note || []).filter((n) => n.tip === "nota").length >
                  0
              ) {
                stareaLaFinalulAnului = "Promovat";
              }

              return {
                id: elevId,
                numeFormatat,
                mediaGenerala: parseFloat(mediaGenerala) || 0,
                materiiCuProbleme,
                initiala: elevData.initiala || "",
                cnp: elevData.cnp || "",
                parintii: elevData.parintii || [],
                numarMatricol: elevData.numarMatricol || "",
                numarTelefon: elevData.numarTelefon || "",
                domiciliu: elevData.domiciliu || "",
                mama: elevData.mama || "",
                tata: elevData.tata || "",
                loculNasteri: elevData.loculNasteri || "",
                bursa: elevData.bursa || "",
                scutitMedical: elevData.scutitMedical || "",
                dataExpirareMedical: elevData.dataExpirareMedical
                  ? new Date(elevData.dataExpirareMedical).toLocaleDateString()
                  : "",
                ces: elevData.ces || "",
                religie: elevData.religie || "da",
                cerereReligie: elevData.cerereReligie || "",
                premiu: elevData.premiu || "",
                profindr: elevData.profindr || "",
                insprin: elevData.insprin || "",
                inssec: elevData.inssec || "",
                details: elevData.details || "",
                materiiSpecialitate: elevData.materiiSpecialitate || [],
                stareaLaIncheiereaCursurilor,
                stareaLaFinalulAnului,
                retras: elevData.retras || false,
                mutat: elevData.mutat || false,
                transferuri: elevData.transferuri || [],
              };
            }
            return null;
          })
          .filter((elev) => elev !== null);

        setEleviData(eleviWithData);

        // Check for incomplete statuses
        const incompletElevi = [];
        setIncompletStatusElevi(incompletElevi);

        // Check for incomplete fields for all students
        const requiredFields = [
          "domiciliu",
          "numarTelefon",
          "numarMatricol",
          "cnp",
          "mama",
          "tata",
          "initiala",
        ];
        const incompletFields = {};

        requiredFields.forEach((field) => {
          const eleviWithMissingField = eleviWithData.filter(
            (elev) =>
              !elev?.[field] ||
              (typeof elev?.[field] === "string" && elev[field].trim() === "")
          );
          if (eleviWithMissingField.length > 0) {
            incompletFields[field] = eleviWithMissingField;
          }
        });

        setIncompleteFieldsData(incompletFields);

        // Initialize editing data
        const initialEditingData = {};
        eleviWithData.forEach((elev) => {
          initialEditingData[elev.id] = { ...elev };
        });
        setEditingData(initialEditingData);
      } catch (error) {
        console.error("Error fetching elevi data:", error);
      }

      setLoading(false);
    };

    fetchEleviData();
  }, [classData, materii]);

  const getUserIdByEmail = async (email) => {
    try {
      // Creează o interogare pentru a căuta documentul utilizatorului după email
      const q = query(
        collection(db, "users"),
        where("emailParinte", "==", email)
      );

      // Execută interogarea
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Dacă există un document, returnăm `uid` din primul document găsit
        const userDoc = querySnapshot.docs[0];
        const userData = userDoc.data();

        console.log("User ID găsit:", userDoc.id); // `userDoc.id` este `uid` al utilizatorului
        return userDoc.id; // Returnăm `userId` (document ID)
      } else {
        console.log("Nu am găsit niciun utilizator cu acest email.");
        return null;
      }
    } catch (error) {
      console.error("Eroare la căutarea utilizatorului:", error);
      return null;
    }
  };

  const sortedData = [...eleviData].sort((a, b) => {
    console.log(a);
    if (sortType === "alfabetic") {
      return a.numeFormatat.localeCompare(b.numeFormatat);
    } else if (sortType === "media") {
      const mediaComparison = b.mediaGenerala - a.mediaGenerala;
      if (mediaComparison === 0) {
        return a.numeFormatat.localeCompare(b.numeFormatat);
      }
      return mediaComparison;
    }
    return 0;
  });

  const toggleColumn = (columnKey) => {
    setActiveColumns((prev) =>
      prev.includes(columnKey)
        ? prev.filter((key) => key !== columnKey)
        : [...prev, columnKey]
    );
  };

  const handleInputChange = (elevId, field, value) => {
    setEditingData((prev) => ({
      ...prev,
      [elevId]: {
        ...prev[elevId],
        [field]: value,
      },
    }));
  };

  // Funcție pentru actualizarea documentelor profesorilor
  const updateProfesoriDocuments = async (
    materiiVechi,
    materiiNoi,
    elevId,
    clasa
  ) => {
    try {
      // Calculează numărul de instanțe pentru fiecare profesor în materiile vechi și noi
      const countProfessorInstances = (materii) => {
        const counts = {};
        (materii || []).forEach((m) => {
          (m.profesori || []).forEach((profId) => {
            counts[profId] = (counts[profId] || 0) + 1;
          });
        });
        return counts;
      };

      const profesoriVechiCounts = countProfessorInstances(materiiVechi);
      const profesoriNoiCounts = countProfessorInstances(materiiNoi);

      // Pentru fiecare profesor, calculează diferența de instanțe
      const allProfessors = [
        ...new Set([
          ...Object.keys(profesoriVechiCounts),
          ...Object.keys(profesoriNoiCounts),
        ]),
      ];

      for (const profesorId of allProfessors) {
        const vechiCount = profesoriVechiCounts[profesorId] || 0;
        const noiCount = profesoriNoiCounts[profesorId] || 0;
        const diferenta = noiCount - vechiCount;

        const profesorData = await getDataDoc("users", profesorId);
        let claseExistente = profesorData?.clase || [];

        if (diferenta > 0) {
          // Adaugă instanțe noi ale clasei
          for (let i = 0; i < diferenta; i++) {
            claseExistente.push(clasa);
          }
          await updateDocDatabase("users", profesorId, {
            clase: claseExistente,
          });
        } else if (diferenta < 0) {
          // Șterge instanțe ale clasei
          for (let i = 0; i < Math.abs(diferenta); i++) {
            const indexToRemove = claseExistente?.findIndex((c) => c === clasa);
            if (indexToRemove !== -1) {
              claseExistente.splice(indexToRemove, 1);
            }
          }
          await updateDocDatabase("users", profesorId, {
            clase: claseExistente,
          });
        }
      }
    } catch (error) {
      console.error("Eroare la actualizarea documentelor profesorilor:", error);
    }
  };

  const saveIndividualElev = async (elevId) => {
    setSavingIndividual((prev) => ({ ...prev, [elevId]: true }));

    try {
      const elevData = editingData[elevId];
      // Obține datele vechi pentru comparare
      const elevDataVechi = await getDataDoc("elevi", elevId);
      const materiiVechi = elevDataVechi?.materiiSpecialitate || [];
      const updateData = {
        initiala: elevData.initiala,
        cnp: elevData.cnp,
        parintii: elevData.parintii,
        numarMatricol: elevData.numarMatricol,
        numarTelefon: elevData.numarTelefon,
        domiciliu: elevData.domiciliu,
        mama: elevData.mama,
        tata: elevData.tata,
        loculNasteri: elevData.loculNasteri,
        bursa: elevData.bursa,
        scutitMedical: elevData.scutitMedical,
        ces: elevData.ces,
        religie: elevData.religie,
        cerereReligie: elevData.cerereReligie,
        premiu: elevData.premiu,
        profindr: elevData.profindr,
        insprin: elevData.insprin,
        inssec: elevData.inssec,
        details: elevData.details,
        materiiSpecialitate: elevData.materiiSpecialitate,
        stareaLaIncheiereaCursurilor: elevData.stareaLaIncheiereaCursurilor,
        stareaLaFinalulAnului: elevData.stareaLaFinalulAnului,
      };

      await updateDocDatabase("elevi", elevId, updateData);

      // Șterge elevul din conturile părinților care au fost eliminați din lista de abonați
      const elevDataVechiParinti = await getDataDoc("elevi", elevId);
      if (elevDataVechiParinti?.parintii) {
        // Iterează prin lista de părinți vechi din documentul elevului
        for await (let parinte of elevDataVechiParinti.parintii) {
          if (!elevData.parintii?.find((p) => p === parinte)) {
            // Găsește userId-ul pe baza emailului părintelui
            const userId = await getUserIdByEmail(parinte);

            if (userId) {
              // Obține documentul utilizatorului
              const dataParinte = await getDataDoc("users", userId);

              if (dataParinte?.copii) {
                // Filtrează câmpul copii pentru a elimina elevul
                const copiiActualizati = dataParinte?.copii?.filter(
                  (copil) => copil.idElev !== elevId
                );
                const eleviA = dataParinte?.elevi?.filter(
                  (copil) => copil !== elevId
                );

                // Actualizează documentul utilizatorului în Firestore
                await updateDocDatabase("users", userId, {
                  copii: copiiActualizati || [],
                  elevi: eleviA || [],
                });

                console.log(
                  `Elevul ${elevId} a fost eliminat din documentul părintelui ${userId}.`
                );
              }
            }
          }
        }
      }

      // Actualizează documentele profesorilor pentru materiile specializate
      const elevFull = eleviData?.find((e) => e.id === elevId);
      const clasa = elevFull ? classData?.id : null;
      if (clasa) {
        await updateProfesoriDocuments(
          materiiVechi,
          elevData.materiiSpecialitate,
          elevId,
          clasa
        );
      }

      // Procesează părinții abonați - creează conturi și trimite emailuri
      if (elevData.parintii && elevData.parintii.length > 0) {
        // Obține datele complete ale elevului din baza de date
        const elevDataComplet = await getDataDoc("elevi", elevId);
        // Creează numele formatat
        const numeFormatat = `${elevDataComplet.numeDeFamilie || ""} ${
          elevDataComplet.initiala || ""
        } ${elevDataComplet.prenume || ""}`.trim();

        const firebaseConfig = {
          apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
          authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
          projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
          storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
          messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
          appId: process.env.REACT_APP_FIREBASE_APP_ID,
        };

        for await (let email of elevData.parintii) {
          let pass = generateSixDigitCode();

          let Secondary = initializeApp(firebaseConfig, "secondary");
          let auth2 = getAuth(Secondary);
          try {
            await createUserWithEmailAndPassword(auth2, email, pass).then(
              async (userCredentials) => {
                const user = userCredentials.user;
                await updateDocDatabase(
                  "mail",
                  "utilizator" + pass + Date.now(),
                  {
                    to: [email].filter(e => e && !e.includes("dobriceansoftware")),
                    message: {
                      subject:
                        "Ați fost înregistrat ca utilizator abonat pentru elevul " +
                        numeFormatat,
                      html: `
                      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8f9fa;">
                        <div style="background-color: #ffffff; border-radius: 10px; padding: 30px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                          <div style="text-align: center; margin-bottom: 30px;">
                            <h1 style="color: #2c3e50; margin-bottom: 10px;">👨‍👩‍👧‍👦 Bine ați venit!</h1>
                            <h2 style="color: #34495e; font-weight: normal; margin: 0;">Cont utilizator creat cu succes</h2>
                          </div>
                          
                          <div style="background-color: #e8f4f8; border-left: 4px solid #3498db; padding: 20px; margin: 20px 0; border-radius: 0 5px 5px 0;">
                            <h3 style="color: #2c3e50; margin-top: 0;">Stimate utilizator,</h3>
                            <p style="color: #34495e; line-height: 1.6; margin-bottom: 0;">
                              Ați fost înregistrat ca utilizator abonat pentru elevul <strong>${numeFormatat}</strong>. 
                              Prin acest cont veți putea urmări progresul școlar al elevului.
                            </p>
                          </div>
                          
                          <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 20px; margin: 20px 0;">
                            <h3 style="color: #856404; margin-top: 0;">🔑 Datele dumneavoastră de autentificare:</h3>
                            <table style="width: 100%; border-collapse: collapse;">
                              <tr>
                                <td style="padding: 8px 0; color: #495057; font-weight: bold;">Email:</td>
                                <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace;">${email}</td>
                              </tr>
                              <tr>
                                <td style="padding: 8px 0; color: #495057; font-weight: bold;">Parolă temporară:</td>
                                <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace; font-weight: bold;">${pass}</td>
                              </tr>
                            </table>
                          </div>
                          
                          <div style="text-align: center; margin: 30px 0;">
                            <a href="${
                              process.env.REACT_APP_LINK
                            }?email=${encodeURIComponent(email)}&pass=${pass}" 
                               style="display: inline-block; background-color: #e74c3c; color: white; padding: 12px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; box-shadow: 0 3px 6px rgba(231, 76, 60, 0.3);">
                              👤 Accesează contul
                            </a>
                            <div style="margin-top: 15px; padding: 10px; background-color: #f8f9fa; border-radius: 5px;">
                              <p style="color: #6c757d; font-size: 12px; margin: 5px 0;">Dacă butonul nu funcționează, copiați și lipiți acest link în browser:</p>
                              <p style="color: #495057; font-size: 12px; word-break: break-all; margin: 0;">
                                ${
                                  process.env.REACT_APP_LINK
                                }?email=${encodeURIComponent(
                        email
                      )}&pass=${pass}
                              </p>
                            </div>
                          </div>
                          
                          <div style="background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                            <p style="color: #721c24; margin: 0; text-align: center;">
                              <strong>⚠️ Important:</strong> Din motive de securitate, veți fi obligat să vă schimbați parola la prima autentificare.
                            </p>
                          </div>
                          
                          <div style="background-color: #d1ecf1; border: 1px solid #bee5eb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                            <h4 style="color: #0c5460; margin-top: 0;">📊 Ce puteți face cu acest cont:</h4>
                            <ul style="color: #0c5460; margin-bottom: 0; padding-left: 20px;">
                              <li>Vizualizați notele elevului</li>
                              <li>Monitorizați temele și proiectele</li>
                              <li>Primiți notificări despre progresul școlar</li>
                              <li>Comunicați cu profesorii</li>
                            </ul>
                          </div>
                          
                          <div style="border-top: 1px solid #dee2e6; padding-top: 20px; margin-top: 30px; text-align: center;">
                            <p style="color: #6c757d; font-size: 14px; margin: 0;">
                              Pentru orice întrebări sau probleme tehnice, vă rugăm să contactați administratorul școlii.
                            </p>
                          </div>
                        </div>
                      </div>
                    `,
                    },
                  }
                );
                await updateProfile(user, { emailVerified: true });
                signOut(auth2);
                await updateDocDatabase("users", user?.uid, {
                  reset: true,
                  type: "parinte",
                  uid: user?.uid,
                  emailParinte: email,
                  copii: [
                    {
                      adresaEmail: elevDataComplet.adresaEmail || "",
                      idElev: elevId,
                      prenume: elevDataComplet.prenume || "",
                      displayName: numeFormatat,
                      numeDeFamilie: elevDataComplet.numeDeFamilie || "",
                      scutitMedical: elevDataComplet.scutitMedical || "",
                      dataExpirareMedical:
                        elevDataComplet.dataExpirareMedical || "",
                      ces: elevDataComplet.ces || "",
                      religie: elevDataComplet.religie || "",
                      cerereReligie: elevDataComplet.cerereReligie || "",
                    },
                  ],
                  elevi: [elevId],
                });
              }
            );
          } catch (err) {
            const q = query(
              collection(db, "users"),
              where("emailParinte", "==", email)
            );
            let data = undefined;

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
              data = doc.data();
            });

            if (data?.uid) {
              await updateDocDatabase("users", data.uid, {
                copii: [
                  ...(data.copii || []).filter((e) => e.idElev !== elevId),
                  {
                    adresaEmail: elevDataComplet.adresaEmail || "",
                    idElev: elevId,
                    prenume: elevDataComplet.prenume || "",
                    displayName: numeFormatat,
                    numeDeFamilie: elevDataComplet.numeDeFamilie || "",
                    scutitMedical: elevDataComplet.scutitMedical || "",
                    dataExpirareMedical:
                      elevDataComplet.dataExpirareMedical || "",
                    ces: elevDataComplet.ces || "",
                    religie: elevDataComplet.religie || "",
                    cerereReligie: elevDataComplet.cerereReligie || "",
                  },
                ],
                elevi: [
                  ...(data.elevi || []).filter((e) => e !== elevId),
                  elevId,
                ],
              });
            }
          }
        }
      }

      message.success(
        `Datele pentru ${elevData.numeFormatat} au fost salvate!`
      );
    } catch (error) {
      console.error("Error saving elev data:", error);
      message.error("Eroare la salvarea datelor!");
    }

    setSavingIndividual((prev) => ({ ...prev, [elevId]: false }));
  };

  const saveAllElevi = async () => {
    setSaving(true);

    try {
      const promises = Object.keys(editingData).map(async (elevId) => {
        const elevData = editingData[elevId];

        // Obține datele vechi pentru comparare
        const elevDataVechi = await getDataDoc("elevi", elevId);
        const materiiVechi = elevDataVechi?.materiiSpecialitate || [];

        const updateData = {
          initiala: elevData.initiala,
          cnp: elevData.cnp,
          parintii: elevData.parintii,
          numarMatricol: elevData.numarMatricol,
          numarTelefon: elevData.numarTelefon,
          domiciliu: elevData.domiciliu,
          mama: elevData.mama,
          tata: elevData.tata,
          loculNasteri: elevData.loculNasteri,
          bursa: elevData.bursa,
          scutitMedical: elevData.scutitMedical,
          ces: elevData.ces,
          religie: elevData.religie,
          cerereReligie: elevData.cerereReligie,
          premiu: elevData.premiu,
          profindr: elevData.profindr,
          insprin: elevData.insprin,
          inssec: elevData.inssec,
          details: elevData.details,
          materiiSpecialitate: elevData.materiiSpecialitate,
          stareaLaIncheiereaCursurilor: elevData.stareaLaIncheiereaCursurilor,
          stareaLaFinalulAnului: elevData.stareaLaFinalulAnului,
        };

        await updateDocDatabase("elevi", elevId, updateData);

        // Șterge elevul din conturile părinților care au fost eliminați din lista de abonați
        const elevDataVechiSaveAll = await getDataDoc("elevi", elevId);
        if (elevDataVechiSaveAll?.parintii) {
          // Iterează prin lista de părinți vechi din documentul elevului
          for await (let parinte of elevDataVechiSaveAll.parintii) {
            if (!elevData.parintii?.find((p) => p === parinte)) {
              // Găsește userId-ul pe baza emailului părintelui
              const userId = await getUserIdByEmail(parinte);

              if (userId) {
                // Obține documentul utilizatorului
                const dataParinte = await getDataDoc("users", userId);

                if (dataParinte?.copii) {
                  // Filtrează câmpul copii pentru a elimina elevul
                  const copiiActualizati = dataParinte?.copii?.filter(
                    (copil) => copil.idElev !== elevId
                  );
                  const eleviA = dataParinte?.elevi?.filter(
                    (copil) => copil !== elevId
                  );

                  // Actualizează documentul utilizatorului în Firestore
                  await updateDocDatabase("users", userId, {
                    copii: copiiActualizati || [],
                    elevi: eleviA || [],
                  });

                  console.log(
                    `Elevul ${elevId} a fost eliminat din documentul părintelui ${userId}.`
                  );
                }
              }
            }
          }
        }

        // Actualizează documentele profesorilor pentru materiile specializate
        const clasa = classData?.id;
        if (clasa) {
          await updateProfesoriDocuments(
            materiiVechi,
            elevData.materiiSpecialitate,
            elevId,
            clasa
          );
        }

        // Procesează părinții abonați - creează conturi și trimite emailuri
        if (elevData.parintii && elevData.parintii.length > 0) {
          // Obține datele complete ale elevului din baza de date
          const elevDataComplet = await getDataDoc("elevi", elevId);

          // Creează numele formatat
          const numeFormatat = `${elevDataComplet.numeDeFamilie || ""} ${
            elevDataComplet.initiala || ""
          } ${elevDataComplet.prenume || ""}`.trim();

          const firebaseConfig = {
            apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId:
              process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
          };

          for await (let email of elevData.parintii) {
            let pass = generateSixDigitCode();

            let Secondary = initializeApp(firebaseConfig, "secondary");
            let auth2 = getAuth(Secondary);
            try {
              await createUserWithEmailAndPassword(auth2, email, pass).then(
                async (userCredentials) => {
                  const user = userCredentials.user;
                  await updateDocDatabase(
                    "mail",
                    "utilizator" + pass + Date.now(),
                    {
                      to: [email].filter(e => e && !e.includes("dobriceansoftware")),
                      message: {
                        subject:
                          "Ați fost înregistrat ca utilizator abonat pentru elevul " +
                          numeFormatat,
                        html: `
                        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8f9fa;">
                          <div style="background-color: #ffffff; border-radius: 10px; padding: 30px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                            <div style="text-align: center; margin-bottom: 30px;">
                              <h1 style="color: #2c3e50; margin-bottom: 10px;">👨‍👩‍👧‍👦 Bine ați venit!</h1>
                              <h2 style="color: #34495e; font-weight: normal; margin: 0;">Cont utilizator creat cu succes</h2>
                            </div>
                            
                            <div style="background-color: #e8f4f8; border-left: 4px solid #3498db; padding: 20px; margin: 20px 0; border-radius: 0 5px 5px 0;">
                              <h3 style="color: #2c3e50; margin-top: 0;">Stimate utilizator,</h3>
                              <p style="color: #34495e; line-height: 1.6; margin-bottom: 0;">
                                Ați fost înregistrat ca utilizator abonat pentru elevul <strong>${numeFormatat}</strong>. 
                                Prin acest cont veți putea urmări progresul școlar al elevului.
                              </p>
                            </div>
                            
                            <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 20px; margin: 20px 0;">
                              <h3 style="color: #856404; margin-top: 0;">🔑 Datele dumneavoastră de autentificare:</h3>
                              <table style="width: 100%; border-collapse: collapse;">
                                <tr>
                                  <td style="padding: 8px 0; color: #495057; font-weight: bold;">Email:</td>
                                  <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace;">${email}</td>
                                </tr>
                                <tr>
                                  <td style="padding: 8px 0; color: #495057; font-weight: bold;">Parolă temporară:</td>
                                  <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace; font-weight: bold;">${pass}</td>
                                </tr>
                              </table>
                            </div>
                            
                            <div style="text-align: center; margin: 30px 0;">
                              <a href="${
                                process.env.REACT_APP_LINK
                              }?email=${encodeURIComponent(
                          email
                        )}&pass=${pass}" 
                                 style="display: inline-block; background-color: #e74c3c; color: white; padding: 12px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; box-shadow: 0 3px 6px rgba(231, 76, 60, 0.3);">
                                👤 Accesează contul
                              </a>
                              <div style="margin-top: 15px; padding: 10px; background-color: #f8f9fa; border-radius: 5px;">
                                <p style="color: #6c757d; font-size: 12px; margin: 5px 0;">Dacă butonul nu funcționează, copiați și lipiți acest link în browser:</p>
                                <p style="color: #495057; font-size: 12px; word-break: break-all; margin: 0;">
                                  ${
                                    process.env.REACT_APP_LINK
                                  }?email=${encodeURIComponent(
                          email
                        )}&pass=${pass}
                                </p>
                              </div>
                            </div>
                            
                            <div style="background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                              <p style="color: #721c24; margin: 0; text-align: center;">
                                <strong>⚠️ Important:</strong> Din motive de securitate, veți fi obligat să vă schimbați parola la prima autentificare.
                              </p>
                            </div>
                            
                            <div style="background-color: #d1ecf1; border: 1px solid #bee5eb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                              <h4 style="color: #0c5460; margin-top: 0;">📊 Ce puteți face cu acest cont:</h4>
                              <ul style="color: #0c5460; margin-bottom: 0; padding-left: 20px;">
                                <li>Vizualizați notele elevului</li>
                                <li>Monitorizați temele și proiectele</li>
                                <li>Primiți notificări despre progresul școlar</li>
                                <li>Comunicați cu profesorii</li>
                              </ul>
                            </div>
                            
                            <div style="border-top: 1px solid #dee2e6; padding-top: 20px; margin-top: 30px; text-align: center;">
                              <p style="color: #6c757d; font-size: 14px; margin: 0;">
                                Pentru orice întrebări sau probleme tehnice, vă rugăm să contactați administratorul școlii.
                              </p>
                            </div>
                          </div>
                        </div>
                      `,
                      },
                    }
                  );
                  await updateProfile(user, { emailVerified: true });
                  signOut(auth2);
                  await updateDocDatabase("users", user?.uid, {
                    reset: true,
                    type: "parinte",
                    uid: user?.uid,
                    emailParinte: email,
                    copii: [
                      {
                        adresaEmail: elevDataComplet.adresaEmail || "",
                        idElev: elevId,
                        prenume: elevDataComplet.prenume || "",
                        displayName: numeFormatat,
                        numeDeFamilie: elevDataComplet.numeDeFamilie || "",
                        scutitMedical: elevDataComplet.scutitMedical || "",
                        dataExpirareMedical:
                          elevDataComplet.dataExpirareMedical || "",
                        ces: elevDataComplet.ces || "",
                        religie: elevDataComplet.religie || "",
                        cerereReligie: elevDataComplet.cerereReligie || "",
                      },
                    ],
                    elevi: [elevId],
                  });
                }
              );
            } catch (err) {
              const q = query(
                collection(db, "users"),
                where("emailParinte", "==", email)
              );
              let data = undefined;

              const querySnapshot = await getDocs(q);
              querySnapshot.forEach((doc) => {
                data = doc.data();
              });

              if (data?.uid) {
                await updateDocDatabase("users", data.uid, {
                  copii: [
                    ...(data.copii || []).filter((e) => e.idElev !== elevId),
                    {
                      adresaEmail: elevDataComplet.adresaEmail || "",
                      idElev: elevId,
                      prenume: elevDataComplet.prenume || "",
                      displayName: numeFormatat,
                      numeDeFamilie: elevDataComplet.numeDeFamilie || "",
                      scutitMedical: elevDataComplet.scutitMedical || "",
                      dataExpirareMedical:
                        elevDataComplet.dataExpirareMedical || "",
                      ces: elevDataComplet.ces || "",
                      religie: elevDataComplet.religie || "",
                      cerereReligie: elevDataComplet.cerereReligie || "",
                    },
                  ],
                  elevi: [
                    ...(data.elevi || []).filter((e) => e !== elevId),
                    elevId,
                  ],
                });
              }
            }
          }
        }
      });

      await Promise.all(promises);
      message.success("Toate datele au fost salvate cu succes!");
    } catch (error) {
      console.error("Error saving all elevi data:", error);
      message.error("Eroare la salvarea datelor!");
    }

    setSaving(false);
  };

  const baseColumns = [
    {
      title: "Nr.",
      dataIndex: "index",
      key: "index",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Nume",
      dataIndex: "numeFormatat",
      key: "numeFormatat",
      width: 200,
      render: (nume, record) => {
        const getStatusText = () => {
          if (
            record.retras === true ||
            record.mutat === true ||
            classData.elevi?.find((e) => e.id === record.id)?.mutat === true
          ) {
            return " - transferat";
          }
          return "";
        };

        return (
          <Button
            type="link"
            style={{
              padding: 0,
              height: "auto",
              textAlign: "left",
              fontSize: "14px",
              fontWeight: "normal",
              color:
                record.retras === true || record.mutat === true
                  ? "#ff4d4f"
                  : undefined,
            }}
            onClick={() => navigate(`/elev/${record.id}`)}
          >
            {nume}
            {getStatusText()}
          </Button>
        );
      },
    },
    {
      title: "Media Generală",
      dataIndex: "mediaGenerala",
      key: "mediaGenerala",
      width: 120,
      render: (media) => {
        if (media === 0) return "-";
        return (
          <span
            style={{
              fontWeight: "bold",
              color: "52c41a",
            }}
          >
            {media.toFixed(2)}
          </span>
        );
      },
    },
    // {
    //   title: "Materii cu Probleme",
    //   dataIndex: "materiiCuProbleme",
    //   key: "materiiCuProbleme",
    //   width: 200,
    //   render: (materiiCuProbleme, record) => {
    //     if (!materiiCuProbleme || materiiCuProbleme?.length === 0) {
    //       return "-";
    //     }
    //     return (
    //       <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
    //         {materiiCuProbleme.map((materie, index) => {
    //           const materieData = materii?.find(
    //             (m) => m.id === materie.materieId
    //           );
    //           return (
    //             <span
    //               key={index}
    //               style={{
    //                 backgroundColor:
    //                   materie.tip === "corigent" ? "#ff4d4f" : "#faad14",
    //                 color: "white",
    //                 padding: "2px 6px",
    //                 borderRadius: "4px",
    //                 fontSize: "12px",
    //                 whiteSpace: "nowrap",
    //               }}
    //               title={`${materieData?.numeMaterie || "N/A"} - ${
    //                 materie.tip === "corigent" ? "Corigent" : "Media neînchisă"
    //               } (${materie.media})`}
    //             >
    //               {materieData?.numeMaterie || "N/A"}
    //             </span>
    //           );
    //         })}
    //       </div>
    //     );
    //   },
    // },
  ];

  const dynamicColumns = availableColumns
    .filter((col) => activeColumns.includes(col.key))
    .map((col) => ({
      title: col.label,
      dataIndex: col.dataKey,
      key: col.key,
      width: col.key === "materiiSpecialitate" ? 450 : 150,
      render: (_, record) => {
        const isStatusField =
          col.dataKey === "stareaLaIncheiereaCursurilor" ||
          col.dataKey === "stareaLaFinalulAnului";
        const isAwardField = col.dataKey === "premiu";
        const shouldHighlight = false;

        if (isStatusField) {
          const allStates = [...defaultStates, ...customStates];
          const currentValue = editingData[record.id]?.[col.dataKey] || "";
          if (
            classData?.elevi?.find((e) => e.id === record.id).mutat === true ||
            classData?.elevi?.find((e) => e.id === record.id).retras === true
          )
            return <></>;
          return (
            <Select
              size="small"
              value={currentValue || undefined}
              onChange={(value) =>
                handleInputChange(record.id, col.dataKey, value)
              }
              placeholder={col.label}
              style={{
                width: "100%",
                backgroundColor: shouldHighlight ? "#fff2f0" : undefined,
              }}
              dropdownRender={(menu) => (
                <div>
                  {menu}
                  <div
                    style={{ padding: "8px 0", borderTop: "1px solid #d9d9d9" }}
                  >
                    <Button
                      type="link"
                      style={{ width: "100%", textAlign: "left" }}
                      onClick={() => {
                        setCurrentStateField(`${record.id}|${col.dataKey}`);
                        setShowAddStateModal(true);
                      }}
                    >
                      + Adaugă stare nouă
                    </Button>
                  </div>
                </div>
              )}
            >
              {allStates.map((state) => (
                <Select.Option key={state} value={state}>
                  {state}
                </Select.Option>
              ))}
            </Select>
          );
        }

        if (isAwardField) {
          const allAwards = [...defaultAwards, ...customAwards];
          const currentValue = editingData[record.id]?.[col.dataKey] || "";

          return (
            <Select
              size="small"
              value={currentValue || undefined}
              onChange={(value) =>
                handleInputChange(record.id, col.dataKey, value)
              }
              placeholder={col.label}
              style={{
                width: "100%",
              }}
              dropdownRender={(menu) => (
                <div>
                  {menu}
                  <div
                    style={{ padding: "8px 0", borderTop: "1px solid #d9d9d9" }}
                  >
                    <Button
                      type="link"
                      style={{ width: "100%", textAlign: "left" }}
                      onClick={() => {
                        setCurrentAwardField(`${record.id}|${col.dataKey}`);
                        setShowAddAwardModal(true);
                      }}
                    >
                      + Adaugă premiu nou
                    </Button>
                  </div>
                </div>
              )}
            >
              {allAwards.map((award) => (
                <Select.Option key={award} value={award}>
                  {award}
                </Select.Option>
              ))}
            </Select>
          );
        }

        if (col.dataKey === "religie") {
          const currentValue = editingData[record.id]?.[col.dataKey] || "da";

          return (
            <Select
              size="small"
              value={currentValue}
              onChange={(value) =>
                handleInputChange(record.id, col.dataKey, value)
              }
              placeholder="Religie"
              style={{
                width: "100%",
                minWidth: "200px",
              }}
            >
              <Select.Option value="da">Face religie</Select.Option>
              <Select.Option value="penticostala">
                Face religie penticostală
              </Select.Option>
              <Select.Option value="nu">Nu face religie</Select.Option>
            </Select>
          );
        }

        if (col.dataKey === "cerereReligie") {
          // Show the field always when cerereReligie column is active
          return (
            <Input
              size="small"
              value={editingData[record.id]?.[col.dataKey] || ""}
              onChange={(e) =>
                handleInputChange(record.id, col.dataKey, e.target.value)
              }
              placeholder="Cerere religie"
              style={{
                width: "100%",
                backgroundColor: shouldHighlight ? "#fff2f0" : undefined,
                borderColor: shouldHighlight ? "#ff4d4f" : undefined,
              }}
            />
          );
        }

        if (col.dataKey === "parintii") {
          const parintii = editingData[record.id]?.parintii || [];

          return (
            <Select
              mode="tags"
              size="small"
              value={parintii}
              onChange={(value) =>
                handleInputChange(
                  record.id,
                  col.dataKey,
                  value.map((item) => item.trim())
                )
              }
              placeholder="Emailuri utilizatori abonați"
              style={{
                width: "100%",
                minWidth: "200px",
              }}
            />
          );
        }

        if (col.dataKey === "materiiSpecialitate") {
          const materiiSpecialitate =
            editingData[record.id]?.materiiSpecialitate || [];

          return (
            <div style={{ minWidth: "400px", maxWidth: "600px" }}>
              {materiiSpecialitate.map((materie, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      display: "block",
                      gap: "10px",
                      width: "100%",
                      marginBottom: "8px",
                      padding: "8px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "4px",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <Select
                      showSearch
                      style={{ width: "100%", marginBottom: "4px" }}
                      placeholder="Materie"
                      optionFilterProp="children"
                      value={materie.materie}
                      onChange={(value) => {
                        const newMateriiSpecialitate = [...materiiSpecialitate];
                        newMateriiSpecialitate[index].materie = value;
                        handleInputChange(
                          record.id,
                          col.dataKey,
                          newMateriiSpecialitate
                        );
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={materii
                        .filter((mat) => mat.orar !== true || mat.id === materie.materie) // Exclude materiile cu orar: true DACĂ nu e materia selectată
                        .map((mat) => {
                          return {
                            label: mat?.numeMaterie + "-" + mat?.profil,
                            value: mat?.id,
                          };
                        })}
                      size="small"
                    />
                    <Select
                      mode="multiple"
                      style={{ width: "100%", marginBottom: "4px" }}
                      showSearch
                      placeholder="Profesor"
                      optionFilterProp="children"
                      value={materie.profesori}
                      onChange={(value) => {
                        const newMateriiSpecialitate = [...materiiSpecialitate];
                        newMateriiSpecialitate[index].profesori = value;
                        handleInputChange(
                          record.id,
                          col.dataKey,
                          newMateriiSpecialitate
                        );
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={profesori.map((prof) => {
                        return {
                          label: prof?.numeDeFamilie + "-" + prof?.prenume,
                          value: prof?.id,
                        };
                      })}
                      size="small"
                    />
                    <Button
                      icon={<DeleteOutlined />}
                      danger
                      size="small"
                      onClick={() => {
                        const newMateriiSpecialitate =
                          materiiSpecialitate.filter(
                            (ma) => ma.materie !== materie?.materie
                          );
                        handleInputChange(
                          record.id,
                          col.dataKey,
                          newMateriiSpecialitate
                        );
                      }}
                    />
                  </div>
                );
              })}
              <Button
                onClick={() => {
                  const newMateriiSpecialitate = [
                    ...materiiSpecialitate,
                    { materie: "", profesori: [] },
                  ];
                  handleInputChange(
                    record.id,
                    col.dataKey,
                    newMateriiSpecialitate
                  );
                }}
                icon={<PlusOutlined />}
                size="small"
                type="dashed"
                style={{ width: "100%" }}
              >
                Adaugă Materie Specială
              </Button>
            </div>
          );
        }

        return (
          <Input
            size="small"
            value={editingData[record.id]?.[col.dataKey] || ""}
            onChange={(e) =>
              handleInputChange(record.id, col.dataKey, e.target.value)
            }
            placeholder={col.label}
            style={{
              backgroundColor: shouldHighlight ? "#fff2f0" : undefined,
              borderColor: shouldHighlight ? "#ff4d4f" : undefined,
            }}
          />
        );
      },
    }));

  const actionColumn = {
    title: "Acțiuni",
    key: "actions",
    width: 100,
    render: (_, record) => (
      <Button
        type="primary"
        size="small"
        loading={savingIndividual[record.id]}
        onClick={() => saveIndividualElev(record.id)}
      >
        Save
      </Button>
    ),
  };

  const columns = [
    ...baseColumns,
    ...dynamicColumns,
    ...(activeColumns.length > 0 ? [actionColumn] : []),
  ];

  return (
    <div style={{ padding: "20px" }}>
      {incompletStatusElevi?.length > 0 && (
        <div
          style={{
            backgroundColor: "#fff2f0",
            border: "1px solid #ffccc7",
            borderRadius: "6px",
            padding: "12px",
            marginBottom: "16px",
            color: "#a8071a",
          }}
        >
          <strong>⚠️ Aveți stări necompletate!</strong>{" "}
          {incompletStatusElevi?.length} elev(i) cu probleme la materii nu au
          starea completată.
        </div>
      )}
      {Object.keys(incompletFieldsData).length > 0 && (
        <div
          style={{
            backgroundColor: "#fff7e6",
            border: "1px solid #ffd591",
            borderRadius: "6px",
            padding: "12px",
            marginBottom: "16px",
            color: "#d46b08",
          }}
        >
          <strong>⚠️ Date incomplete!</strong> Următoarele câmpuri au date
          lipsă:
          <ul style={{ margin: "8px 0 0 0", paddingLeft: "20px" }}>
            {Object.entries(incompletFieldsData).map(([field, students]) => {
              const fieldLabel =
                availableColumns.find((col) => col.dataKey === field)?.label ||
                field;
              return (
                <li key={field}>
                  <strong>{fieldLabel}</strong>: {students.length} elev(i)
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div style={{ marginBottom: "16px" }}>
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <Button
            type={sortType === "alfabetic" ? "primary" : "default"}
            onClick={() => setSortType("alfabetic")}
          >
            Sortare Alfabetică
          </Button>
          <Button
            type={sortType === "media" ? "primary" : "default"}
            onClick={() => setSortType("media")}
          >
            Sortare după Media
          </Button>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            marginTop: "10px",
          }}
        >
          {availableColumns.map((col) => {
            const hasIncompleteData =
              incompletFieldsData[col.dataKey] &&
              incompletFieldsData[col.dataKey].length > 0;
            return (
              <Button
                key={col.key}
                size="small"
                type={activeColumns.includes(col.key) ? "primary" : "default"}
                onClick={() => toggleColumn(col.key)}
                style={{
                  fontSize: "12px",
                  backgroundColor:
                    hasIncompleteData && !activeColumns.includes(col.key)
                      ? "#ff4d4f"
                      : undefined,
                  borderColor:
                    hasIncompleteData && !activeColumns.includes(col.key)
                      ? "#ff4d4f"
                      : undefined,
                  color:
                    hasIncompleteData && !activeColumns.includes(col.key)
                      ? "white"
                      : undefined,
                }}
              >
                {col.label}
                {hasIncompleteData &&
                  ` (${incompletFieldsData[col.dataKey].length})`}
              </Button>
            );
          })}
        </div>

        {activeColumns.length > 0 && (
          <div style={{ marginTop: "10px" }}>
            <Button
              type="primary"
              size="large"
              loading={saving}
              onClick={saveAllElevi}
              style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
            >
              Salvează Toți Elevii
            </Button>
          </div>
        )}
      </div>

      <Table
        columns={columns}
        dataSource={sortedData}
        loading={loading}
        rowKey="id"
        pagination={{
          pageSize: 100,
          showSizeChanger: true,
          showTotal: (total, range) => {
            const eleviCuProbleme = sortedData.filter(
              (elev) =>
                elev.materiiCuProbleme && elev.materiiCuProbleme?.length > 0
            ).length;
            return `${range[0]}-${range[1]} din ${total} elevi (${eleviCuProbleme} cu probleme)`;
          },
        }}
        size="middle"
        bordered
        style={{ backgroundColor: "white" }}
        scroll={{ x: columns.length * 150 + 200 }}
      />

      {/* Modal for adding new state */}
      <Modal
        title="Adaugă stare nouă"
        open={showAddStateModal}
        onOk={handleAddNewState}
        onCancel={() => {
          setShowAddStateModal(false);
          setNewStateName("");
          setCurrentStateField("");
        }}
        okText="Adaugă"
        cancelText="Anulează"
      >
        <div style={{ marginBottom: "16px" }}>
          <label>Nume stare nouă:</label>
          <Input
            value={newStateName}
            onChange={(e) => setNewStateName(e.target.value)}
            placeholder="Introduceți numele stării"
            onPressEnter={handleAddNewState}
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ fontSize: "12px", color: "#666" }}>
          Stările existente: {[...defaultStates, ...customStates].join(", ")}
        </div>
      </Modal>

      {/* Modal for adding new award */}
      <Modal
        title="Adaugă premiu nou"
        open={showAddAwardModal}
        onOk={handleAddNewAward}
        onCancel={() => {
          setShowAddAwardModal(false);
          setNewAwardName("");
          setCurrentAwardField("");
        }}
        okText="Adaugă"
        cancelText="Anulează"
      >
        <div style={{ marginBottom: "16px" }}>
          <label>Nume premiu nou:</label>
          <Input
            value={newAwardName}
            onChange={(e) => setNewAwardName(e.target.value)}
            placeholder="Introduceți numele premiului"
            onPressEnter={handleAddNewAward}
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ fontSize: "12px", color: "#666" }}>
          Premiile existente: {[...defaultAwards, ...customAwards].join(", ")}
        </div>
      </Modal>
    </div>
  );
}

export default DateElevi;
